module.exports = __webpack_public_path__ + "img/alipay.7a6bfcfd.svg";